import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import Table from './../../../../../../components/table';
import { getAddress, getFullName } from './../../../../../../utilities/string';
import { formSettings } from './../settings';
import { getAdmin } from '../../../../../../reducers/onboarding';
import { dateToFloatingString } from '../../../../../../utilities/dateTime';
import { getProjectsRateLabelAndValue } from '../../../../../../utilities/rate';
import mixpanel from 'mixpanel-browser';

class AcknowledgmentStep extends React.Component {
    constructor(props) {
        super(props);

        this.getTableData = this.getTableData.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'intro', step: 'AcknowledgementStep' } });

        const { admin, client, getAdmin } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    getTableData() {
        const { projects, job, address, hiring_manager } = this.props;
        const { start_date, end_date } = job;

        let contractPeriod = <span>{`${dateToFloatingString(start_date)} - ${end_date ? dateToFloatingString(end_date) : ' '}*`}</span>;

        let workLocation = <FormattedMessage {...messages.notProvided} />;
        if (job.work_location_type === 'offsite') {
            workLocation = <FormattedMessage {...messages.workLocationAtYourLocation} />;
        } else if (address) {
            workLocation = getAddress(address);
        }

        const payType = getProjectsRateLabelAndValue(job, projects);

        return {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                { label: <FormattedMessage {...messages.contractPeriod} />, value: contractPeriod },
                { label: <FormattedMessage {...messages.workLocation} />, value: workLocation },
                payType,
                {
                    label: <FormattedMessage {...messages.reportingTo} />,
                    value: hiring_manager ? getFullName(hiring_manager) : <FormattedMessage {...messages.notProvided} />
                }
            ]
        };
    }

    render() {
        const { handleSubmit, onSubmit, submitting, client, job, admin } = this.props;
        if (!job || !admin) {
            return null;
        }

        let tableData = this.getTableData();
        const titleVowel = job.title && 'aeiou'.includes(job.title.slice(0, 1).toLowerCase());
        const article = titleVowel ? 'an' : 'a';

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row section">
                    <div className="col-xs-12">
                        <h1 className="onboarding-title">
                            <FormattedHTMLMessage
                                id={'job.Subtitle'}
                                defaultMessage={
                                    "You are starting as {article} <span class='highlight'>{title}</span> at <span class='highlight'>{company}</span> on "
                                }
                                values={{ title: job.title, company: client.name, article: article }}
                                tagName={'span'}
                            />
                            <span className="highlight">{dateToFloatingString(job.start_date)}</span>
                        </h1>
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <Table {...tableData} rowStyle={'onboarding-table-row'} />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <blockquote>
                            <FormattedMessage
                                id={'job.estimatedStartDate'}
                                defaultMessage={"*These are target dates. They're subject to change until all the loose ends are tied up."}
                                tagName={'p'}
                            />
                        </blockquote>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center">
                        <button className="get-started-button" type="submit" disabled={submitting}>
                            <FormattedMessage id={'contractorWelcome.letsGo'} defaultMessage="Let's Go!" />
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

AcknowledgmentStep = reduxForm(formSettings)(AcknowledgmentStep);

const mapStateToProps = state => ({
    role: state.identity.role,
    admin: state.onboarding.admin,
    client: state.onboarding.client,
    agreementSigned: state.onboarding.progression.agreementSigned
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin,
            getProjectsRateLabelAndValue
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AcknowledgmentStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/intro/acknowledgement.jsx